import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// Try to get the language from localStorage first
const savedLanguage = localStorage.getItem('language');
const initialLanguage = savedLanguage || 'en';

i18n
  // Detect user language
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
      queryStringParams: {
        v: process.env.REACT_APP_BUILD_ID || 'dev',
      },
    },
    debug: process.env.NODE_ENV === 'development',
    fallbackLng: 'en',
    lng: initialLanguage,
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'language',
      caches: ['localStorage']
    },
  });

// Save language changes to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;